import React from 'react';
import { FaPlay, FaPause, FaFlag } from 'react-icons/fa';

const ProgressIndicator = ({ currentPhase, overallProgress, status }) => {
  const getStatusIcon = () => {
    switch (status) {
      case 'completed':
        return <FaFlag className="status-icon completed" />;
      case 'paused':
        return <FaPause className="status-icon paused" />;
      case 'active':
      default:
        return <FaPlay className="status-icon active" />;
    }
  };

  const getStatusText = () => {
    switch (status) {
      case 'completed':
        return 'Journey Complete';
      case 'paused':
        return 'Journey Paused';
      case 'active':
      default:
        return 'Journey in Progress';
    }
  };

  const getPhaseDisplay = () => {
    if (status === 'completed') return '7/7';
    return `${Math.min(currentPhase, 7)}/7`;
  };

  const getProgressColor = () => {
    if (overallProgress >= 100) return '#28a745'; // Green
    if (overallProgress >= 60) return '#17a2b8'; // Blue
    if (overallProgress >= 30) return '#ffc107'; // Yellow
    return '#6c757d'; // Gray
  };

  // Create the circular progress indicator
  const radius = 45;
  const circumference = 2 * Math.PI * radius;
  const strokeDasharray = circumference;
  const strokeDashoffset = circumference - (overallProgress / 100) * circumference;

  return (
    <div className="progress-indicator">
      <div className="progress-circle">
        <svg width="120" height="120" className="progress-svg">
          {/* Background circle */}
          <circle
            cx="60"
            cy="60"
            r={radius}
            stroke="#e9ecef"
            strokeWidth="8"
            fill="transparent"
          />
          
          {/* Progress circle */}
          <circle
            cx="60"
            cy="60"
            r={radius}
            stroke={getProgressColor()}
            strokeWidth="8"
            fill="transparent"
            strokeLinecap="round"
            strokeDasharray={strokeDasharray}
            strokeDashoffset={strokeDashoffset}
            className="progress-circle-fill"
          />
        </svg>
        
        <div className="progress-content">
          <div className="progress-percentage">{overallProgress}%</div>
          <div className="progress-phase">Phase {getPhaseDisplay()}</div>
        </div>
      </div>

      <div className="progress-details">
        <div className="progress-status">
          {getStatusIcon()}
          <span className="status-text">{getStatusText()}</span>
        </div>
        
        <div className="progress-description">
          {status === 'completed' ? (
            <span>Congratulations! Your change management journey is complete.</span>
          ) : (
            <span>
              Currently in Phase {currentPhase}: Navigate through each phase to guide your change initiative.
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProgressIndicator; 